export const captchaFullUrl = (url: string): string => `${process.env.NEXT_PUBLIC_API_URL}v2${url}`;
